var exports = {
  "k": "calendarIcon__Rid3WU",
};

module.exports = exports;
